import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class CanonicalService {
  private link!: HTMLLinkElement;
  private init: boolean = false;
  private dom = inject(DOCUMENT);

  createCanonicalLink(url: string) {
    if (!this.init) {
      this.link = this.dom.createElement('link');
      this.link.setAttribute('rel', 'canonical');
      this.dom.head.appendChild(this.link);
      this.link.setAttribute('href', url);
      this.init = true;
    } else {
      this.link.setAttribute('href', url);
    }
  }
}
